import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ReferenceBrandType } from '@1po/1po-bff-fe-spec/generated/catalog/references/common/model/ReferenceBrandType';
import { ROUTER_CATALOG_VEHICLE } from 'app/AppRouter';
import { RootState } from 'app/AppStore';
import { getExadisEquivalentsForRdVehiclesEnabled } from 'domains/appContext/AppContext.store';
import { getLastSearchedVehicleKey } from 'domains/catalog/Catalog.store';
import { getIAMCatalogSourcePaths } from 'domains/catalog/Catalog.utils';
import { getIsExadisEligible } from 'domains/references';
import { ExadisButton, Flex, Text } from 'UI';

const Exadis = ({
  referenceNumber,
  referenceBrand,
  compactView = false,
}: {
  referenceNumber: string;
  referenceBrand?: ReferenceBrandType;
  compactView?: boolean;
}) => {
  const history = useHistory();
  const exadisEquivalentsForRdVehiclesEnabled = useSelector(getExadisEquivalentsForRdVehiclesEnabled);
  const isExadisEligible = useSelector((state: RootState) => getIsExadisEligible(state, referenceNumber));
  const vehicleKey = useSelector(getLastSearchedVehicleKey);
  const { t } = useTranslation();
  const isRdReference = referenceBrand !== 'MOTRIO' && referenceBrand !== 'IAM';
  if (!exadisEquivalentsForRdVehiclesEnabled || !isExadisEligible || !isRdReference) {
    return null;
  }

  const handleClick = () => {
    const vehicleKeyPath = vehicleKey ? `/${vehicleKey}` : '';
    const dottedReference = encodeURIComponent(`${referenceNumber}.`);
    history.push(
      `${getIAMCatalogSourcePaths(vehicleKeyPath)}${ROUTER_CATALOG_VEHICLE}/search/${dottedReference}?hideMotrio=true`,
    );
  };

  return (
    <Flex maxWidth={250}>
      <ExadisButton data-cy={'exadis-button'} size={compactView ? 'small' : 'middle'} onClick={handleClick}>
        <Text type="sm" ellipsis noWrap color={'white'}>
          {t('catalog.exadis_catalog', 'Exadis')}
        </Text>
      </ExadisButton>
    </Flex>
  );
};

export default Exadis;
